import * as React from "react";
import { forwardRef } from "react";
const SvgPlayOutline = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ref={ref} {...props}><path stroke="currentColor" d="M5.07 20.153V4.707c0-1.41 1.567-2.256 2.746-1.483l11.768 7.724a1.773 1.773 0 0 1 0 2.964L7.816 21.635c-1.18.774-2.746-.072-2.746-1.482Z" /></svg>;
const ForwardRef = forwardRef(SvgPlayOutline);
export default ForwardRef;